/**
 * 门户边框默认配置数据
 */
export const home = [
  {
    color:"#333",
    lineHeight : 36,
    showIcon: true,
    iconStyle: 1,
    wordWrap: false,
    showWeatherText : true,
    iconSize : 20, //天气图标的宽度
    showIconOrder : 1,
    showCityOrder : 2,
    showWeatherTextOrder : 3,
    showTempOrder : 4
},
  {
      styleId:2,
      color:"#333",
      lineHeight : 36,
      showIcon: true,
      iconStyle: 2,
      wordWrap: false,
      showWeatherText : true,
      iconSize : 20, //天气图标的宽度
      showIconOrder : 1,
      showCityOrder : 2,
      showWeatherTextOrder : 3,
      showTempOrder : 4 },
  {
      styleId:3,
    color:"#333",
        lineHeight : 25,
      showIcon: false,
      iconStyle: 1,
      wordWrap: true,
      showWeatherText : true,
      iconSize : 20, //天气图标的宽度
      showIconOrder : 1,
      showCityOrder : 2,
      showWeatherTextOrder : 3,
      showTempOrder : 4
  }
]

/**
 * 大屏边框默认配置数据
 */
export const bs = [
  { showIcon: true, showCity: false, iconStyle: 1, showWeatherText: false, wordWrap: false, fontSize: 21,fontWeight: 400, },
  { styleId:2,showIcon: true, showCity: false, iconStyle: 2, showWeatherText: false, wordWrap: false, fontSize: 21,fontWeight: 400, },
  { styleId:3,fontSize: 21, fontWeight: 400 }
]

/**
 * app天气默认配置数据
 */
export const appHome = [
  {
    color:"#333",
    lineHeight : 36,
    showIcon: true,
    iconStyle: 1,
    wordWrap: false,
    showWeatherText : true,
    iconSize : 20, //天气图标的宽度
    showIconOrder : 2,
    showCityOrder : 1,
    showWeatherTextOrder : 3,
    showTempOrder : 4
},
  {
      styleId:2,
      color:"#333",
      lineHeight : 36,
      showIcon: true,
      iconStyle: 2,
      wordWrap: false,
      showWeatherText : true,
      iconSize : 20, //天气图标的宽度
      showIconOrder : 2,
      showCityOrder : 1,
      showWeatherTextOrder : 3,
      showTempOrder : 4 },
  {
      styleId:3,
    color:"#333",
        lineHeight : 25,
      showIcon: false,
      iconStyle: 1,
      wordWrap: true,
      showWeatherText : true,
      iconSize : 20, //天气图标的宽度
      showIconOrder : 2,
      showCityOrder : 1,
      showWeatherTextOrder : 3,
      showTempOrder : 4
  }
]
